import Allergen from "@/model/allergen";
import Option from "@/model/option";

class MenuProduct {
  constructor({
    allergens,
    description,
    id,
    image,
    banner,
    name,
    options,
    price
  }) {
    this.allergens = allergens;
    this.description = description;
    this.id = id;
    this.image = image;
    this.banner = banner;
    this.name = name;
    this.options = options;
    this.price = price;
  }
  get totalPrice() {
    let price = Number(this.price);
    if (this.options) {
      this.options.forEach(option => (price += Number(option.addedPrice)));
    }

    return price;
  }
  clone() {
    return this.constructor._fromMap(this._toMap());
  }
  toMap() {
    return {
      allergens: this.allergens
        ? this.allergens.map(allergen => allergen.toMap())
        : [],
      description: this.description,
      id: this.id,
      image: this.image,
      banner: this.banner,
      name: this.name,
      options: this.options ? this.options.map(option => option.toMap()) : [],
      price: this.price
    };
  }

  static fromMap(snapData) {
    snapData.allergens = snapData.allergens
      ? snapData.allergens.map(allergen => Allergen.fromMap(allergen))
      : [];
    snapData.options = snapData.options
      ? snapData.options.map(option => Option.fromMap(option))
      : [];
    return new MenuProduct(snapData);
  }
}

export default MenuProduct;
